import { addBusinessDays } from './businessDays'

export const QA_MILESTONE_NAMES = new Set(['Incoming', 'RTS', 'Incoming / RTS', 'INCOMING', 'INCOMING / RTS'])

// ── QA seed tracking (localStorage) ──────────────────────────────────────────
// Tracks which project IDs have ever had QA milestones seeded so that
// intentional deletions (existing.length === 0 after seeding) are respected.
const QA_SEEDED_KEY = 'qa_milestones_seeded_v1'

export function getQASeededSet() {
  try { return new Set(JSON.parse(localStorage.getItem(QA_SEEDED_KEY) || '[]')) } catch { return new Set() }
}

export function markQASeeded(projectId) {
  try {
    const s = getQASeededSet()
    s.add(projectId)
    localStorage.setItem(QA_SEEDED_KEY, JSON.stringify([...s]))
  } catch {}
}

// Returns subtask-ready objects (no id — let the DB generate it).
export function generateQASubtasks(projectId, arrivalDate, departureDate) {
  if (!projectId || !arrivalDate || !departureDate) return []

  const calSpan = Math.round(
    (new Date(departureDate + 'T00:00:00') - new Date(arrivalDate + 'T00:00:00')) / 86400000
  )

  const prevBizDay = addBusinessDays(arrivalDate, -1)
  const base = { project_id: projectId, department: 'QA', status: 'Scheduled' }

  if (calSpan === 0) {
    return [{ ...base, task_name: 'INCOMING / RTS', start_date: arrivalDate, end_date: arrivalDate }]
  }

  if (calSpan === 1) {
    return [
      { ...base, task_name: 'INCOMING', start_date: prevBizDay,    end_date: arrivalDate    },
      { ...base, task_name: 'RTS',      start_date: departureDate, end_date: departureDate  },
    ]
  }

  const prevBizDayDep = addBusinessDays(departureDate, -1)
  return [
    { ...base, task_name: 'INCOMING', start_date: prevBizDay,    end_date: arrivalDate    },
    { ...base, task_name: 'RTS',      start_date: prevBizDayDep, end_date: departureDate  },
  ]
}
